var LSTouch;

LSTouch = {
  init: function() {
    return $('body').on('touchend', 'a.lstouch', function(e) {
      var doubleTouch, target, timestamp, touchTicket;
      target = e.currentTarget;
      touchTicket = target.touchTimestamp || 0;
      timestamp = new Date().getTime();
      doubleTouch = (timestamp - touchTicket) < 300;
      target.touchTimestamp = timestamp;
      e.lsDoubleTouch = doubleTouch;
      e.type = 'lstouch';
      return $(target).trigger(e);
    });
  }
};

module.exports = LSTouch;

